function IncreaseProductQuantity(mainProductId) {
    fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
            let cartItems = cart.items;
            let updates = {};
            let mainProduct = cartItems.find(item => item.id == mainProductId);
          
            if (!mainProduct) {
              if(document.querySelector('.quick-cart__footer')?.classList.contains("disable-btn")){
                document.querySelector('.quick-cart__footer')?.classList.remove("disable-btn")
              }
                return;
            }
             let bundledProducts = cartItems.filter(item => 
                item.properties && item.properties._product_id && 
                item.properties._product_id.toString() === mainProductId.toString()
            );
          
           bundledProducts.forEach(item => {
            updates[item.id] = item.quantity + 1;
           });

          

            fetch(`/cart/update.js`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ updates })
            })
            .then(response => response.json())
            .then( async (data) => {
             
              
             await refreshCart();
             if(document.querySelector('.quick-cart__buy-now.visible')?.classList.contains("disable-btn")){
                document.querySelector('.quick-cart__buy-now.visible')?.classList.remove("disable-btn")
              }
               if(document.querySelector('.quick-cart__footer')?.classList.contains("disable-btn")){
                document.querySelector('.quick-cart__footer')?.classList.remove("disable-btn")
              }
              
            })
            .catch(error => console.error('Error updating cart:', error));
        })
        .catch(error => console.error('Error fetching cart:', error));
}

function DecreaseProductQuantity(mainProductId){
    
    fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
        let cartItems = cart.items;
        let updates = {};

        let mainProduct = cartItems.find(item => item.id == mainProductId);
        let bundledProducts = cartItems.filter(item => 
            item.properties && item.properties._product_id && 
            item.properties._product_id.toString() === mainProductId.toString()
        );
      
        if (!mainProduct && bundledProducts.lenght <= 0 ) {
             if(document.querySelector('.quick-cart__footer')?.classList.contains("disable-btn")){
                document.querySelector('.quick-cart__footer')?.classList.remove("disable-btn")
              }
            if(document.querySelector('.quick-cart__buy-now.visible')?.classList.contains("disable-btn")){
                document.querySelector('.quick-cart__buy-now.visible')?.classList.remove("disable-btn")
              } 
            return;
        }

        bundledProducts.forEach(item => {
            updates[item.id] = item.quantity - 1;
        });

        fetch(`/cart/update.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates })
        })
        .then(response => response.json())
        .then( async (data) => {
            await refreshCart();
             if(document.querySelector('.quick-cart__buy-now.visible')?.classList.contains("disable-btn")){
                document.querySelector('.quick-cart__buy-now.visible')?.classList.remove("disable-btn")
              } 
             if(document.querySelector('.quick-cart__footer')?.classList.contains("disable-btn")){
                document.querySelector('.quick-cart__footer')?.classList.remove("disable-btn")
              } 
            })
        .catch(error => console.error('Error updating cart:', error));
    })
    .catch(error => console.error('Error fetching cart:', error));
}




async function removeAddOnItem(mainProductId) {

 
    fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
            let cartItems = cart.items;
            let updates = {};

            cartItems.forEach(item => {
                if (
                    item.properties &&
                    item.properties._product_id &&
                    item.properties._product_id.toString() === mainProductId.toString()
                ) {
                    updates[item.id] = 0;
                }
            });

          
            if (Object.keys(updates).length === 0) {
           
              if(document.querySelector('.quick-cart__footer')?.classList.contains("disable-btn")){
                document.querySelector('.quick-cart__footer')?.classList.remove("disable-btn")
              } 
               if(window.location.pathname == '/cart') {
                  setTimeout(() => {
                      location.reload();
                    }, 300);
                }
              
                return;
            }

         

            fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ updates })
            })
            .then(response => response.json())
            .then(async (data) => {
               
          
              if(window.location.pathname != '/cart') await refreshCart();
              
              if(window.location.pathname == '/cart') {
                  setTimeout(() => {
                      location.reload();
                    }, 300);
                }
              
             if(document.querySelector('.quick-cart__buy-now.visible')?.classList.contains("disable-btn")){
                document.querySelector('.quick-cart__buy-now.visible')?.classList.remove("disable-btn")
              } 
             if(document.querySelector('.quick-cart__footer')?.classList.contains("disable-btn")){
                document.querySelector('.quick-cart__footer')?.classList.remove("disable-btn")
              } 
              
               
            })
            .catch(error => console.error('Error updating cart:', error));
        })
        .catch(error => console.error('Error fetching cart:', error));
}



function validateAddOnsAndCleanCart() {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const cartItems = cart.items;
      const mainProductsToRemove = [];
    
      cartItems.forEach(mainItem => {
       
        const hasAddons = mainItem.properties && mainItem.properties["_has_addons"]?.trim()  == "true";

        if (hasAddons) {
          const mainProductId = mainItem.id.toString();

          
          const addonExists = cartItems.some(item => {
            return (
              item.properties &&
              item.properties._product_id &&
              item.properties._product_id.toString() === mainProductId
            );
          });

          if (!addonExists) {
            mainProductsToRemove.push(mainItem.id);
          }
        }
      });

      if (mainProductsToRemove.length > 0) {
        const updates = {};
        mainProductsToRemove.forEach(id => {
          updates[id] = 0;
        });

        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates })
        })
        .then(response => response.json())
        .then(async () => {
          if (window.location.pathname != '/cart') await refreshCart();
          if (window.location.pathname == '/cart') {
            setTimeout(() => {
              location.reload();
            }, 300);
          }
        })
        .catch(error => console.error('Error updating cart:', error));

      } else {

         if(window.location.pathname=='/cart')
            document.querySelector(".original-cart-checkout-btn")?.click();
         else
           document.querySelector(".original-checkout-btn")?.click()
      }
    })
    .catch(err => console.error("Error fetching cart:", err));
}



function handleQuantityChange(mainProductId, changeType) {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const updates = {};
      
      
      const mainProduct = cart.items.find(item => item.id == mainProductId);
      if (!mainProduct) return;

     
      const currentQty = mainProduct.quantity;
      const newQty = changeType === 'increment' ? currentQty + 1 : currentQty - 1;
      if (newQty < 0) return; 
      updates[mainProduct.id] = newQty;

      
      const bundledProducts = cart.items.filter(item =>
        item.properties &&
        item.properties._product_id &&
        item.properties._product_id.toString() === mainProductId.toString()
      );

     
      bundledProducts.forEach(item => {
        const currentQty = item.quantity;
        const newQty = changeType === 'increment' ? currentQty + 1 : currentQty - 1;
        if (newQty >= 0) {
          updates[item.id] = newQty;
        }
      });

    
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates })
      });
    })
    .then(response => response.json())
    .then(async () => {
        location.reload();
      if(document.querySelector('.checkout-btn')?.classList.contains("disable-btn")) document.querySelector('.checkout-btn')?.classList.remove("disable-btn");
    })
    .catch(error => console.error('Error updating cart:', error));
}
